import {connect} from '@modifi/redux'
import {selectExtraLinks} from '../../../../../data/navigation'

import SignUpButton, {SignUpButtonProps} from './SignUpButton'

const mapStateToProps = (state: Record<string, any>): Pick<SignUpButtonProps, 'signUpUrl'> => ({
  signUpUrl: selectExtraLinks(state)?.signup,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpButton)
